<template>
  <div id="Dashboard" class="Dashboard">
    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>

      <!-- KPI -->
      <a-row :gutter="8">
        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="green"
            fluid
            class="dashboard-kpi-card"
          >
            <div slot="header">
              <strong>
                TỔNG MÃ THÀNH CÔNG / TỔNG GIẢI THƯỞNG
              </strong>
            </div>

            <div class="dashboard-kpi-content">
              <a-progress
                type="circle"
                :width="110"
                :percent="SuccessAwardPercent"
              />

              <div class="dashboard-kpi-value">
                <b>
                  {{ FormatNumber(Summary.Award_Success) }}
                </b>
                <span>
                  /
                  {{ FormatNumber(Summary.Award_Total) }}
                </span>
              </div>
            </div>
          </fish-card>
        </a-col>

        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="blue"
            fluid
            class="dashboard-kpi-card"
          >
            <div slot="header">
              <strong>
                LƯỢT NHẮN HÔM NAY / TỔNG LƯỢT NHẮN
              </strong>
            </div>

            <div class="dashboard-kpi-content">
              <a-progress
                type="circle"
                :width="110"
                :percent="TodayEntryPercent"
              />

              <div class="dashboard-kpi-value">
                <b>
                  {{ FormatNumber(Summary.Entry_Today) }}
                </b>
                <span>
                  /
                  {{ FormatNumber(Summary.Entry_Total) }}
                </span>
              </div>
            </div>
          </fish-card>
        </a-col>

        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="yellow"
            fluid
            class="dashboard-kpi-card"
          >
            <div slot="header">
              <strong>
                MÃ THÀNH CÔNG HÔM NAY / TỔNG MÃ THÀNH CÔNG
              </strong>
            </div>

            <div class="dashboard-kpi-content">
              <a-progress
                type="circle"
                :width="110"
                :percent="TodaySuccessPercent"
              />

              <div class="dashboard-kpi-value">
                <b>
                  {{ FormatNumber(SuccessToday) }}
                </b>
                <span>
                  /
                  {{ FormatNumber(Summary.Total_Success) }}
                </span>
              </div>
            </div>
          </fish-card>
        </a-col>
      </a-row>

      <!-- Summary -->
      <a-row
        :gutter="8"
        style="margin-top: 8px"
      >
        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="yellow"
            fluid
            class="dashboard-small-card"
          >
            <div slot="header">
              <strong>CHẶN TRONG NGÀY (BLOCK)</strong>
            </div>

            <a-statistic
              :value="Summary.Block_Count || 0"
            >
              <template slot="prefix">
                <a-icon type="stop" />
              </template>
            </a-statistic>
          </fish-card>
        </a-col>

        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="red"
            fluid
            class="dashboard-small-card"
          >
            <div slot="header">
              <strong>DANH SÁCH ĐEN (BLACKLIST)</strong>
            </div>

            <a-statistic
              :value="Summary.BlackList_Count || 0"
            >
              <template slot="prefix">
                <a-icon type="warning" />
              </template>
            </a-statistic>
          </fish-card>
        </a-col>

        <a-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
        >
          <fish-card
            color="green"
            fluid
            class="dashboard-small-card"
          >
            <div slot="header">
              <strong>TỔNG GIÁ TRỊ THÀNH CÔNG</strong>
            </div>

            <div class="dashboard-money">
              {{ FormatMoney(UsedValueTotal) }}
            </div>
          </fish-card>
        </a-col>
      </a-row>

      <hr />

      <fish-row>
        <fish-col
          span="24"
          class="text-left"
        >
          <h1 class="dashboard-report-title">
            <b>
              BÁO CÁO VOUCHER
            </b>
          </h1>

          <div class="dashboard-updated">
            Cập nhật:
            {{ LastUpdated || "--" }}
          </div>
        </fish-col>
      </fish-row>

      <!-- Value chart -->
      <fish-row>
        <fish-col span="24">
          <fish-card fluid>
            <div slot="header">
              <strong>
                GIÁ TRỊ VOUCHER ĐÃ TRÚNG THEO NGÀY
              </strong>
            </div>

            <apexchart
              id="voucher-value-chart"
              width="100%"
              height="320px"
              type="bar"
              :options="ChartOptions"
              :series="ChartSeries"
            ></apexchart>
          </fish-card>
        </fish-col>
      </fish-row>

      <!-- Report table -->
      <fish-row>
        <fish-col span="24">
          <fish-card fluid>
            <div slot="header">
              <strong>
                REPORT THEO NGÀY
              </strong>
            </div>

            <a-table
              row-key="_key"
              size="small"
              :columns="TBLcolumns"
              :data-source="TBLdata"
              :pagination="{
                pageSize: 15,
                showSizeChanger: false
              }"
              :scroll="{ x: 650 }"
            >
              <template
                slot="Entry"
                slot-scope="text"
              >
                {{ FormatNumber(text) }}
              </template>

              <template
                slot="Success_Entry"
                slot-scope="text"
              >
                <b>
                  {{ FormatNumber(text) }}
                </b>
              </template>

              <template
                slot="Success_Percent"
                slot-scope="text"
              >
                {{ FormatPercent(text) }}%
              </template>

              <template
                slot="Value"
                slot-scope="text"
              >
                <b>
                  {{ FormatMoney(text) }}
                </b>
              </template>
            </a-table>
          </fish-card>
        </fish-col>
      </fish-row>
    </fish-segment>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

function Percent(
  Value,
  Total
) {
  const Numerator =
    Number(
      Value || 0
    );

  const Denominator =
    Number(
      Total || 0
    );

  if (
    !Number.isFinite(
      Numerator
    ) ||
    !Number.isFinite(
      Denominator
    ) ||
    Denominator <= 0
  ) {
    return 0;
  }

  return Math.max(
    0,
    Math.min(
      100,
      Number(
        (
          Numerator /
          Denominator *
          100
        ).toFixed(2)
      )
    )
  );
}

export default {
  name:
    "DashBoard",

  data() {
    return {
      isLoading:
        false,

      Timer:
        null,

      LastUpdated:
        "",

      AwardValue:
        0,

      Summary: {
        Award_Success:
          0,

        Award_Total:
          0,

        Entry_Today:
          0,

        Entry_Total:
          0,

        Total_Success:
          0,

        Block_Count:
          0,

        BlackList_Count:
          0,

        Used_Value_Total:
          0
      },

      Reports:
        [],

      TBLcolumns: [{
        title:
          "#",

        dataIndex:
          "Index",

        key:
          "Index",

        width:
          55,

        align:
          "center"
      }, {
        title:
          "NGÀY",

        dataIndex:
          "Date_String",

        key:
          "Date_String",

        width:
          115,

        align:
          "center"
      }, {
        title:
          "LƯỢT NHẮN",

        dataIndex:
          "Entry",

        key:
          "Entry",

        align:
          "right",

        scopedSlots: {
          customRender:
            "Entry"
        }
      }, {
        title:
          "MÃ THÀNH CÔNG",

        dataIndex:
          "Success_Entry",

        key:
          "Success_Entry",

        align:
          "right",

        scopedSlots: {
          customRender:
            "Success_Entry"
        }
      }, {
        title:
          "TỶ LỆ THÀNH CÔNG %",

        dataIndex:
          "Success_Percent",

        key:
          "Success_Percent",

        align:
          "right",

        scopedSlots: {
          customRender:
            "Success_Percent"
        }
      }, {
        title:
          "THÀNH TIỀN",

        dataIndex:
          "Value",

        key:
          "Value",

        align:
          "right",

        scopedSlots: {
          customRender:
            "Value"
        }
      }]
    };
  },

  computed: {
    oUser() {
      return (
        this.$store.state.oUser ||
        {}
      );
    },

    SuccessAwardPercent() {
      return Percent(
        this.Summary.Award_Success,
        this.Summary.Award_Total
      );
    },

    TodayEntryPercent() {
      return Percent(
        this.Summary.Entry_Today,
        this.Summary.Entry_Total
      );
    },

    SuccessToday() {
      /*
       * Ưu tiên API trả thẳng.
       * Nếu chưa có thì lấy từ Report atomic hôm nay.
       */
      const ApiValue =
        Number(
          this.Summary.Success_Today
        );

      if (
        Number.isFinite(
          ApiValue
        ) &&
        ApiValue >= 0 &&
        this.Summary.Success_Today !==
          undefined
      ) {
        return ApiValue;
      }

      const TodayString =
        moment().format(
          "DD/MM/YYYY"
        );

      const TodayReport =
        this.Reports.find(
          Item =>
            Item.Date_String ===
            TodayString
        );

      return Number(
        (
          TodayReport &&
          TodayReport.Success_Entry
        ) ||
        0
      );
    },

    TodaySuccessPercent() {
      return Percent(
        this.SuccessToday,
        this.Summary.Total_Success
      );
    },

    UsedValueTotal() {
      const ApiValue =
        Number(
          this.Summary.Used_Value_Total
        );

      if (
        Number.isFinite(
          ApiValue
        ) &&
        ApiValue > 0
      ) {
        return ApiValue;
      }

      return this.Reports.reduce(
        (
          Total,
          Item
        ) =>
          Total +
          Number(
            Item.Value || 0
          ),
        0
      );
    },

    TBLdata() {
      return this.Reports.map(
        (
          Item,
          Index
        ) => {
          const Entry =
            Number(
              Item.Entry || 0
            );

          const SuccessEntry =
            Number(
              Item.Success_Entry ||
              0
            );

          return {
            ...Item,

            _key:
              Item._id ||
              Item.Date_String ||
              (
                "report_" +
                Index
              ),

            Index:
              Index + 1,

            Entry:
              Entry,

            Success_Entry:
              SuccessEntry,

            Success_Percent:
              Percent(
                SuccessEntry,
                Entry
              ),

            Value:
              Number(
                Item.Value || 0
              )
          };
        }
      );
    },

    ChartCategories() {
      return this.Reports.map(
        Item =>
          this.FormatChartDate(
            Item
          )
      );
    },

    ChartSeries() {
      return [{
        name:
          "Giá trị Success",

        data:
          this.Reports.map(
            Item =>
              Number(
                Item.Value || 0
              )
          )
      }];
    },

    ChartOptions() {
      return {
        chart: {
          id:
            "voucher-value-chart",

          toolbar: {
            show:
              false
          }
        },

        dataLabels: {
          enabled:
            false
        },

        xaxis: {
          categories:
            this.ChartCategories
        },

        yaxis: {
          labels: {
            formatter:
              Value =>
                this.FormatCompactMoney(
                  Value
                )
          }
        },

        tooltip: {
          y: {
            formatter:
              Value =>
                this.FormatMoney(
                  Value
                )
          }
        },

        noData: {
          text:
            "Chưa có dữ liệu report"
        }
      };
    }
  },

  mounted() {
    this.LoadDashboard();

    this.Timer =
      setInterval(
        this.LoadDashboard,
        300000
      );
  },

  beforeDestroy() {
    if (this.Timer) {
      clearInterval(
        this.Timer
      );
    }
  },

  methods: {
    async LoadDashboard() {
      if (this.isLoading) {
        return;
      }

      this.isLoading =
        true;

      try {
        const Response =
          await axios.post(
            this.$PRJ_DOMAIN +
            "/crm/api/dashboard/get-info",
            {
              Token:
                this.oUser.Token ||
                ""
            }
          );

        const Result =
          Response &&
          Response.data !==
          undefined
            ? Response.data
            : Response;

        if (
          !Result ||
          Result.State !==
          1
        ) {
          throw new Error(
            (
              Result &&
              Result.Message
            ) ||
            "Không tải được Dashboard."
          );
        }

        /*
         * Ws_Helper dùng chuẩn:
         * {
         *   State: 1,
         *   Message: "",
         *   Data: {
         *      Award_Value,
         *      Summary,
         *      Reports
         *   }
         * }
         */
        const Data =
          Result.Data || {};

        this.AwardValue =
          Number(
            Data.Award_Value ||
            0
          );

        this.Summary =
          Object.assign(
            {},
            this.Summary,
            Data.Summary ||
            {}
          );

        this.Reports =
          this.NormalizeReports(
            Data.Reports ||
            []
          );

        /*
         * Nếu API chưa trả Total_Success,
         * Report atomic đã đủ để tính.
         */
        if (
          this.Summary.Total_Success ===
            undefined ||
          this.Summary.Total_Success ===
            null
        ) {
          this.Summary.Total_Success =
            this.Reports.reduce(
              (
                Total,
                Item
              ) =>
                Total +
                Number(
                  Item.Success_Entry ||
                  0
                ),
              0
            );
        }

        /*
         * Award_Success chính là total Success
         * theo góc nhìn Guest/đối tác.
         */
        if (
          this.Summary.Award_Success ===
            undefined ||
          this.Summary.Award_Success ===
            null
        ) {
          this.Summary.Award_Success =
            this.Summary.Total_Success;
        }

        this.LastUpdated =
          moment().format(
            "DD/MM/YYYY HH:mm:ss"
          );
      } catch (Error) {
        console.log(
          "Dashboard-Load-Error:",
          Error
        );

        this.$message.error(
          Error.message ||
          "Không kết nối được máy chủ."
        );
      } finally {
        this.isLoading =
          false;
      }
    },

    NormalizeReports(
      Reports
    ) {
      return (
        Array.isArray(
          Reports
        )
          ? Reports
          : []
      )
        .map(
          Item => {
            const Report =
              Object.assign(
                {},
                Item
              );

            /*
             * Model mới có Date_String.
             * Giữ fallback Date để tương thích dữ liệu cũ.
             */
            if (
              !Report.Date_String &&
              Report.Date
            ) {
              const DateValue =
                moment(
                  Report.Date
                );

              if (
                DateValue.isValid()
              ) {
                Report.Date_String =
                  DateValue.format(
                    "DD/MM/YYYY"
                  );
              }
            }

            Report.Entry =
              Number(
                Report.Entry ||
                0
              );

            Report.Success_Entry =
              Number(
                Report.Success_Entry ||
                0
              );

            Report.Value =
              Number(
                Report.Value ||
                0
              );

            return Report;
          }
        )
        .sort(
          (
            A,
            B
          ) => {
            const DateA =
              this.ParseReportDate(
                A
              );

            const DateB =
              this.ParseReportDate(
                B
              );

            return (
              DateA.valueOf() -
              DateB.valueOf()
            );
          }
        );
    },

    ParseReportDate(
      Item
    ) {
      if (
        Item &&
        Item.Date
      ) {
        const DateValue =
          moment(
            Item.Date
          );

        if (
          DateValue.isValid()
        ) {
          return DateValue;
        }
      }

      if (
        Item &&
        Item.Date_String
      ) {
        const DateValue =
          moment(
            Item.Date_String,
            "DD/MM/YYYY",
            true
          );

        if (
          DateValue.isValid()
        ) {
          return DateValue;
        }
      }

      return moment(0);
    },

    FormatChartDate(
      Item
    ) {
      const DateValue =
        this.ParseReportDate(
          Item
        );

      if (
        !DateValue.isValid() ||
        DateValue.valueOf() ===
          0
      ) {
        return (
          Item.Date_String ||
          ""
        );
      }

      return DateValue.format(
        "DD/MM"
      );
    },

    FormatNumber(
      Value
    ) {
      return new Intl
        .NumberFormat(
          "vi-VN"
        )
        .format(
          Number(
            Value || 0
          )
        );
    },

    FormatMoney(
      Value
    ) {
      return new Intl
        .NumberFormat(
          "vi-VN",
          {
            style:
              "currency",

            currency:
              "VND",

            maximumFractionDigits:
              0
          }
        )
        .format(
          Number(
            Value || 0
          )
        );
    },

    FormatCompactMoney(
      Value
    ) {
      const Amount =
        Number(
          Value || 0
        );

      if (
        Math.abs(
          Amount
        ) >=
        1000000000
      ) {
        return (
          (
            Amount /
            1000000000
          ).toFixed(1) +
          " tỷ"
        );
      }

      if (
        Math.abs(
          Amount
        ) >=
        1000000
      ) {
        return (
          (
            Amount /
            1000000
          ).toFixed(1) +
          " tr"
        );
      }

      return this.FormatNumber(
        Amount
      );
    },

    FormatPercent(
      Value
    ) {
      return Number(
        Value || 0
      ).toFixed(2);
    }
  }
};
</script>

<style>
.ant-col {
  padding: 1px !important;
}

.Dashboard {
  padding: 2px;
}

.dashboard-kpi-card {
  min-height: 205px;
}

.dashboard-kpi-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  min-height: 145px;
}

.dashboard-kpi-value {
  color: #303133;
  font-size: 20px;
}

.dashboard-kpi-value b {
  display: inline-block;
  font-size: 30px;
}

.dashboard-kpi-value span {
  color: #606266;
}

.dashboard-small-card {
  min-height: 105px;
}

.dashboard-small-card .ant-statistic {
  padding: 5px 10px;
}

.dashboard-small-card .ant-statistic-content {
  font-size: 30px;
}

.dashboard-money {
  padding: 7px 10px;
  color: #303133;
  font-size: 28px;
  font-weight: 700;
}

.dashboard-report-title {
  margin-bottom: 0;
}

.dashboard-updated {
  margin-bottom: 8px;
  color: #909399;
  font-size: 12px;
}

.fish.row .col {
  padding-right: 2px;
}

.fish.card > .header {
  padding: 0.7em 0.3em !important;
}

@media screen and (max-width: 768px) {
  .dashboard-kpi-content {
    flex-direction: column;
    gap: 10px;
  }

  .dashboard-kpi-card {
    min-height: 260px;
  }
}
</style>
